import { render, staticRenderFns } from "./CDatePicker.vue?vue&type=template&id=01823e67"
import script from "./CDatePicker.vue?vue&type=script&lang=js"
export * from "./CDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01823e67')) {
      api.createRecord('01823e67', component.options)
    } else {
      api.reload('01823e67', component.options)
    }
    module.hot.accept("./CDatePicker.vue?vue&type=template&id=01823e67", function () {
      api.rerender('01823e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/CDatePicker.vue"
export default component.exports